module.exports = __webpack_public_path__ + "static/full-day-section-bubble-2-e9a0a6d229ee3a114b2413bb244a3ded.png";